import { Recurso } from 'eddydata-lib';
import { BaseResourceModel } from '../../models/base-resource.model';
import { EmendaParlamentar } from './emenda-parlamentar.model';

export class EmendaParlamentarRecursoAdicional extends BaseResourceModel {
  constructor(
    public id?: number,
    public emenda?: EmendaParlamentar,
    public recurso?: Recurso,
  ) {
    super();
  }

  static converteJson(json: any): EmendaParlamentarRecursoAdicional {
    return Object.assign(new EmendaParlamentarRecursoAdicional(), json);
  }
}
